import { useTranslation as useI18nextTranslation } from 'react-i18next';
import type { NamespaceKeys, TranslationHookReturn } from '../types';

/**
 * Enhanced useTranslation hook with type safety and Cobli-specific features
 * @param namespace - The translation namespace to use
 * @returns Translation utilities and functions
 */
export function useTranslation(namespace?: NamespaceKeys | NamespaceKeys[]): TranslationHookReturn {
  const { t, i18n } = useI18nextTranslation(namespace);

  return {
    t,
    language: i18n.language,
    isReady: i18n.isInitialized,
  };
}

/**
 * Hook for getting current language information
 */
export function useLanguage() {
  const { i18n } = useI18nextTranslation();

  return {
    currentLanguage: i18n.language,
    isPortuguese: i18n.language === 'pt-BR',
    isEnglish: i18n.language === 'en-US',
    googleMapsLanguage: i18n.language === 'pt-BR' ? 'pt-BR' : 'en-US',
    changeLanguage: async (language: string) => {
      await i18n.changeLanguage(language);
      localStorage.setItem('cobli-language', language);
      window.location.reload();
    },
  };
}
